module.exports = __webpack_public_path__ + "img/upload_bg_07.e1cb849f.png";